import { useState } from "react";
import { colors } from "../components/landing/colors";
import { LandingHeader } from "../components/landing/LandingHeader";
import { HeroSection } from "../components/landing/HeroSection";
import { PartnerSection, ServicesSection } from "../components/landing/CompetenciesSection";
import { ProjectsGrid } from "../components/landing/ProjectsGrid";
import { TrustSection, CtaSection } from "../components/landing/CtaSection";
import { LandingFooter } from "../components/landing/LandingFooter";

export default function LandingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    setMobileMenuOpen(false);
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen font-['Inter',system-ui,sans-serif]" style={{ backgroundColor: colors.darkBlue, fontSize: "90%" }}>
      <LandingHeader
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        scrollToSection={scrollToSection}
      />
      <HeroSection scrollToSection={scrollToSection} />
      <PartnerSection />
      <ServicesSection />
      <ProjectsGrid />
      <TrustSection />
      <CtaSection />
      <LandingFooter />
    </div>
  );
}
